import React, { FC, ReactNode } from 'react';
import { CONTAINER_STYLES } from '../styles/constants';

interface ContainerProps {
  children: ReactNode;
  className?: string;
  style?: React.CSSProperties;  
}

const Container: FC<ContainerProps> = ({ children, className = '', style }) => {
  return (
    <div className={`${CONTAINER_STYLES.main} ${className}`} style={style}>
      {children}
    </div>
  );
};

export default Container;
